export default __webpack_public_path__ + "static/media/kitchen1-480w.35e67ce8.webp";